module.exports = __webpack_public_path__ + "assets/img/title-b75d2c8b.png";